import { Injectable, Renderer2, RendererFactory2, ElementRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { ToastService } from 'src/app/services/toast.service';
import { combineLatest } from 'rxjs';
import { otherSystemData, pass } from 'src/app/session/store/session.selectors';
import { first, tap } from 'rxjs/operators';


@Injectable()
export class MoodleAccess {

	private readonly MOODLE_REGEXP: RegExp = new RegExp( environment.moodleBaseUrl );
	private readonly MOODLE_LOGIN_URL: string = environment.moodleBaseUrl + "/login/index.php";
	private renderer: Renderer2;

	constructor( private store: Store<AppState>, rendererFactory: RendererFactory2, private toastService: ToastService ) {
		this.renderer = rendererFactory.createRenderer( null, null );
	}

	public isMoodleUrl( url: string ) {
		return this.MOODLE_REGEXP.exec( url ) != null;
	}

	/**
	 * Abre la página principal de Moodle con el usuario de Intranet ya logueado en Moodle.
	 * 
	 * @param url, url de Moodle
	 * @param target: especifica el nombre de un iframe o ventana donde se abrirá la url
	 * @param fromElement: elemento del DOM que solicita la apertura del link de Jira
	 */
	public openMoodle( target: string, fromElement: ElementRef ) {
		combineLatest( [ this.store.select( otherSystemData ), this.store.select( pass ) ] )
			.pipe(
				first(),
				tap( ([ otherSystemData, pass ]) => {
					// Si hay usuario y clave => realizo el login vía el form y luego se redirecciona
					// el resultado del submit al iframe
					// sino => mensaje de error
					if( pass && pass != '' ) {
						let form: any = this.createForm( this.MOODLE_LOGIN_URL, otherSystemData.nombreUsuario, pass, target );
						fromElement.nativeElement.appendChild( form );
						form.submit();
						form.remove();
					} else {
						this.toastService.danger( "No se ha podido abrir la página de Moodle solicitada" );
					}
				})
			).subscribe();
	}

/*
 * private methods
 */	

	/**
	 * Retorna el siguiente formulario como objeto listo para ser agregado al DOM.
	 * 
	 * <form #form action="..." method="post" target="login" style="display: none">
	 *     <input name="os_username" value="...">
	 *     <input name="os_password" value="...">
	 *     <input name="os_cookie" value="true">
	 *     <input name="os_destination" value="...">
	 * </form>
	 */
	private createForm( action: string, user: string, pass: string, target: string ): any {
		// Create input elements
		let username: any = this.renderer.createElement( 'input' );
		this.renderer.setProperty( username, "name", "username" );  
		this.renderer.setProperty( username, "value", user );  
		let password: any = this.renderer.createElement( 'input' );
		this.renderer.setProperty( password, "name", "password" );
		this.renderer.setProperty( password, "value", pass );		
 
		// Create form
		let form: any = this.renderer.createElement( 'form' );
		this.renderer.setStyle( form, "display", "none" );
		this.renderer.setProperty( form, "method", "post" );
		this.renderer.setProperty( form, "action", action );
		this.renderer.setProperty( form, "target", target );
		this.renderer.appendChild( form, username );
		this.renderer.appendChild( form, password );		
		
		return form;
	}

}